// Wizard Steps Components
import Industry from "../components/Steps/Industry";
import Palette from "../components/Steps/Palette";
import Goals from "../components/Steps/Goals";
import Orders from "../components/Steps/Orders";
import RewardActions from "../components/Steps/RewardActions";

const routesConfig = [
	{
		path: "/industry",
		component: Industry,
		name: "industry"
	},
	{
		path: "/design",
		component: Palette,
		name: "design"
	},
	{
		path: "/goals",
		component: Goals,
		name: "goals"
	},
	{
		path: "/orders",
		component: Orders,
		name: "orders"
	},
	{
		path: "/incentives",
		component: RewardActions,
		name: "incentives"
	}
];

export default routesConfig;
